// @flow
import { getCurrentConference } from '../base/conference';
import { JitsiConferenceEvents } from '../base/lib-jitsi-meet';
import { NOTIFICATION_TIMEOUT_TYPE, NOTIFICATION_TYPE, showNotification } from '../notifications';
import { clearPolls, deletePoll, receiveAnswer, receivePoll, updatePoll } from './actions';
import { COMMAND_NEW_POLL, COMMAND_ANSWER_POLL, COMMAND_OLD_POLLS, COMMAND_START_POLLS, COMMAND_END_POLL, COMMAND_REOPEN_POLL, COMMAND_DELETE_POLL, COMMAND_UPDATE_POLL, COMMAND_ADD_OPTION_POLL } from './constants';
import StateListenerRegistry from '../base/redux/StateListenerRegistry';
import { getLocalParticipant } from '../base/participants';
import { openChat, setIsPollsTabFocused } from '../chat/actions.web';
const parsePollData = (pollData) => {
    if (typeof pollData !== 'object' || pollData === null) {
        return null;
    }
    const { question, answers, poll_id, sender_id, sender_name, sender_user_id, status, anonymous_poll, can_add_option, choose_multiple_options, duration, expires_at, end_time, lastVote, remain_duration, start_time, create_time, voters } = pollData;
    // const _answers = answers.map((answer: any) => {
    //     return {
    //         name: answer?.name,
    //         voters: answer?.voters?.__hash ? convertedObject(answer.voters.__hash) : {}
    //     }
    // })
    // let filterSame = _answers?.filter(
    //         (obj: any, index: any) =>
    //         answers?.findIndex((item: any) => item.name === obj.name) === index
    //       );
    if (typeof poll_id !== 'string' || typeof sender_id !== 'string' || typeof sender_name !== 'string'
        || typeof question !== 'string' || !(answers instanceof Array)) {
        return null;
    }
    let answerConvert = answers?.map(item => ({ ...item, voters: new Map(Object.entries(item.voters)) }));
    // const isShowResult = voters.hasOwnProperty(JSON.parse(localStorage.getItem('user'))?.id)
    const isShowResults = answers.some(answer => answer.voters?.hasOwnProperty(JSON.parse(localStorage.getItem('user') || "")?.id));
    return {
        pollId: poll_id,
        changingVote: false,
        senderId: sender_id,
        senderName: sender_name,
        showResults: isShowResults,
        voters,
        lastVote: null,
        senderUserId: sender_user_id,
        status,
        anonymousPoll: anonymous_poll,
        canAddOption: can_add_option,
        chooseMultipleOptions: choose_multiple_options,
        duration,
        question,
        expiresAt: expires_at,
        answers: answerConvert,
        remainDuration: remain_duration,
        end_time,
        expires_at_new: ((new Date()).getTime()) / 1000 + remain_duration,
        startTime: start_time,
        createTime: create_time
    };
};
StateListenerRegistry.register(state => getCurrentConference(state), (conference, store, previousConference) => {
    if (conference && conference !== previousConference) {
        const receiveMessage = (_, data) => {
            switch (data.type) {
                case COMMAND_START_POLLS: {
                    const { question, answers, poll_id, sender_id, sender_name, sender_user_id, status, anonymous_poll, can_add_option, choose_multiple_options, duration, expires_at, remain_duration, start_time } = data;
                    let filterSame = answers?.filter((obj, index) => answers?.findIndex((item) => item.name === obj.name) === index);
                    let answerConvert = filterSame?.map((item) => ({ ...item, voters: new Map(Object.entries(item.voters)) }));
                    const poll = {
                        pollId: poll_id,
                        changingVote: true,
                        senderId: sender_id,
                        senderName: sender_name,
                        showResults: false,
                        lastVote: null,
                        senderUserId: sender_user_id,
                        status,
                        anonymousPoll: anonymous_poll,
                        canAddOption: can_add_option,
                        chooseMultipleOptions: choose_multiple_options,
                        duration,
                        question,
                        answers: answerConvert,
                        expiresAt: expires_at,
                        remainDuration: remain_duration,
                        expires_at_new: ((new Date()).getTime()) / 1000 + remain_duration,
                        startTime: start_time
                    };
                    store.dispatch(receivePoll(poll_id, poll, true));
                    break;
                }
                case COMMAND_NEW_POLL: {
                    const { question, answers, poll_id, sender_id, sender_name, sender_user_id, status, anonymous_poll, can_add_option, choose_multiple_options, duration, start_time, create_time } = data;
                    let filterSame = answers?.filter((obj, index) => answers?.findIndex((item) => item.name === obj.name) === index);
                    let answerConvert = filterSame?.map((item) => ({ ...item, voters: new Map(Object.entries(item.voters)) }));
                    const poll = {
                        pollId: poll_id,
                        changingVote: false,
                        senderId: sender_id,
                        senderName: sender_name,
                        showResults: false,
                        lastVote: null,
                        senderUserId: sender_user_id,
                        status,
                        anonymousPoll: anonymous_poll,
                        canAddOption: can_add_option,
                        chooseMultipleOptions: choose_multiple_options,
                        duration,
                        question,
                        answers: answerConvert,
                        expiresAt: data.expires_at || '',
                        remainDuration: data.remain_duration || '',
                        expires_at_new: data.remain_duration ? (((new Date()).getTime()) / 1000 + (data.remain_duration)) : '',
                        startTime: start_time || '',
                        createTime: create_time
                    };
                    // store.dispatch(updatePoll(poll_id, poll));
                    const { isPollsTabFocused, isOpen } = store.getState()['features/chat'];
                    if ((isPollsTabFocused && !isOpen) || !isPollsTabFocused) {
                        store.dispatch(receivePoll(poll_id, poll, true));
                    }
                    else {
                        store.dispatch(receivePoll(poll_id, poll, false));
                    }
                    const localParticipant = getLocalParticipant(APP.store.getState());
                    if (localParticipant?.id !== sender_id && ((isPollsTabFocused && !isOpen) || !isPollsTabFocused)) {
                        store.dispatch(showNotification({
                            appearance: NOTIFICATION_TYPE.NORMAL,
                            titleKey: 'polls.notification.title',
                            descriptionKey: 'polls.notification.description',
                            customActionNameKey: ['chat.view'],
                            customActionHandler: [() => {
                                    APP.store.dispatch(setIsPollsTabFocused(true));
                                    APP.store.dispatch(openChat());
                                }],
                        }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
                    }
                    break;
                }
                case COMMAND_UPDATE_POLL: {
                    const { question, answers, poll_id, sender_id, sender_name, sender_user_id, status, anonymous_poll, can_add_option, choose_multiple_options, duration } = data;
                    let filterSame = answers?.filter((obj, index) => answers?.findIndex((item) => item.name === obj.name) === index);
                    let answerConvert = filterSame?.map((item) => ({ ...item, voters: new Map(Object.entries(item.voters)) }));
                    const poll = {
                        pollId: poll_id,
                        changingVote: false,
                        senderId: sender_id,
                        senderName: sender_name,
                        showResults: false,
                        lastVote: null,
                        senderUserId: sender_user_id,
                        status,
                        anonymousPoll: anonymous_poll,
                        canAddOption: can_add_option,
                        chooseMultipleOptions: choose_multiple_options,
                        duration,
                        question,
                        answers: answerConvert
                    };
                    store.dispatch(updatePoll(poll_id, poll));
                    break;
                }
                case COMMAND_ANSWER_POLL: {
                    const { poll_id: pollId, answers } = data;
                    let votersById;
                    // const _answers = answers.map((answer: any) => {
                    //     return {
                    //         name: answer?.name,
                    //         voters: answer?.voters?.__hash ? convertedObject(answer.voters.__hash) : {}
                    //     }
                    // })
                    // data.voters = data.voters?.__hash ? convertedObject(data.voters.__hash) : {}
                    // let filterSame = _answers?.filter(
                    //     (obj: any, index: any) =>
                    //     _answers?.findIndex((item: any) => item.name === obj.name) === index
                    // );
                    if (data.voters) {
                        votersById = data?.voters[JSON.parse(localStorage.getItem('user') || "")?.id];
                        let answerConvert = answers?.map((item) => ({ ...item, voters: new Map(Object.entries(item.voters)) }));
                        store.dispatch(receiveAnswer(pollId, answerConvert, votersById));
                    }
                    else {
                        let answerConvert = answers?.map((item) => ({ ...item, voters: new Map(Object.entries(item.voters)) }));
                        store.dispatch(receiveAnswer(pollId, answerConvert));
                    }
                    break;
                }
                case COMMAND_OLD_POLLS: {
                    const { polls } = data;
                    for (const pollData of polls) {
                        const poll = parsePollData(pollData);
                        // let arrAnswer = poll?.answers.map((item) => ({name: item.name, id: Object.fromEntries(item.voters)}))
                        // if(arrAnswer.id?.hasOwnProperty(JSON.parse(localStorage.getItem('user'))?.id)) {
                        //     arrAnswer.id = 
                        // }
                        if (poll === null) {
                            console.warn('[features/polls] Invalid old poll data');
                        }
                        else if (poll?.senderUserId == JSON.parse(localStorage.getItem("user") || "")?.id
                            || poll?.status !== "not_start") {
                            store.dispatch(receivePoll(pollData.poll_id, poll, true));
                        }
                    }
                    break;
                }
                case COMMAND_END_POLL: {
                    const { poll_id, status, end_time, answers, duration } = data;
                    // const _answers = answers.map((answer: any) => {
                    //     return {
                    //         name: answer?.name,
                    //         voters: answer?.voters ? convertedObject(answer.voters.) : {}
                    //     }
                    // })
                    // let filterSame = _answers?.filter(
                    //     (obj: any, index: number) =>
                    //     answers?.findIndex((item: any) => item.name === obj.name) === index
                    //   );
                    let answerConvert = answers?.map((item) => ({ ...item, voters: new Map(Object.entries(item.voters)) }));
                    store.dispatch(updatePoll(poll_id, { status, end_time, answers: answerConvert, showResults: true }));
                    break;
                }
                case COMMAND_REOPEN_POLL: {
                    const { poll_id, status, start_time } = data;
                    store.dispatch(updatePoll(poll_id, { status, duration: -1, startTime: start_time, isAddOption: false, showResults: false }));
                    break;
                }
                case COMMAND_DELETE_POLL: {
                    const { poll_id } = data;
                    store.dispatch(deletePoll(poll_id));
                    break;
                }
                case COMMAND_ADD_OPTION_POLL: {
                    const { poll_id, answers } = data;
                    // const _answers = answers.map((answer: any) => {
                    //     return {
                    //         name: answer?.name,
                    //         voters: answer?.voters?.__hash ? convertedObject(answer.voters.__hash) : {}
                    //     }
                    // })
                    // let filterSame = _answers?.filter(
                    //     (obj: any, index: any) =>
                    //     answers?.findIndex((item: any) => item.name === obj.name) === index
                    //   );
                    let answerConvert = answers?.map((item) => ({ ...item, voters: new Map(Object.entries(item.voters)) }));
                    store.dispatch(updatePoll(poll_id, { answers: answerConvert }));
                    break;
                }
            }
        };
        conference.on(JitsiConferenceEvents.ENDPOINT_MESSAGE_RECEIVED, receiveMessage);
        conference.on(JitsiConferenceEvents.NON_PARTICIPANT_MESSAGE_RECEIVED, receiveMessage);
        // clean old polls
        store.dispatch(clearPolls());
    }
});
